const PRODUCTS_TO_SHOW = 3;
const FETCH_LIMIT = 6;
const SECTION_ID = 'cart-drawer-rec-item';

let cachedItems = null;

async function loadCartRecommendations(carousel) {
  if (!carousel || carousel.dataset.loaded === 'true') return;
  carousel.dataset.loaded = 'true';

  const heading = document.querySelector('.js-cart-rec-heading');
  const dots = document.querySelector('.js-cart-rec-dots');

  // Sofort Cache einfügen → kein Flackern
  if (cachedItems?.length) {
    cachedItems.forEach(el => carousel.appendChild(el.cloneNode(true)));
    if (heading) heading.style.display = '';
    if (dots) dots.style.display = '';
  }

  const cartIds = JSON.parse(carousel.dataset.cartIds || '[]');
  const recUrl = carousel.dataset.recUrl;

  if (!cartIds.length) return;

  const results = await Promise.all(
    cartIds.map(id =>
      fetch(`${recUrl}?product_id=${id}&limit=${FETCH_LIMIT}&section_id=${SECTION_ID}`)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.from(doc.querySelectorAll('.cart-drawer-item'));
        })
        .catch(() => [])
    )
  );

  const seen = new Set(cartIds.map(String));
  const toShow = [];

  for (const el of results.flat()) {
    const id = el.dataset.productId;
    if (id && !seen.has(id) && toShow.length < PRODUCTS_TO_SHOW) {
      seen.add(id);
      toShow.push(el);
    }
  }

  // Cache aktualisieren
  cachedItems = toShow;

  // Neue Produkte einfügen (ersetzt Cache-Inhalte)
  carousel.innerHTML = '';
  if (!toShow.length) {
    if (heading) heading.style.display = 'none';
    if (dots) dots.style.display = 'none';
    return;
  }

  toShow.forEach(el => carousel.appendChild(el));
  if (heading) heading.style.display = '';
  if (dots) dots.style.display = '';
}

document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.getElementById('cart-drawer-recommendations-carousel');
  if (carousel) loadCartRecommendations(carousel);
});

const observer = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      const carousel = node.id === 'cart-drawer-recommendations-carousel'
        ? node
        : node.querySelector?.('#cart-drawer-recommendations-carousel');
      if (carousel) loadCartRecommendations(carousel);
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });